'use client';

import React, { useState } from 'react';
import { cn } from '@/lib/utils';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import {
  BannerStaticDesktop,
  HeroSuaEmpresaProps,
} from './_components/suaempresa';
import { BannerStaticMobile } from './_components/mobile-suaempresa';

const heroData: HeroSuaEmpresaProps[] = [
  {
    flag: 'NOVIDADE',
    titleOrange: 'A CAIXA Pré-Pagos ',
    titleWhite: 'está de cara nova!',
    description:
      'Descubra com mais facilidade soluções inteligentes de pagamento eletrônico que facilitam a gestão de mobilidade e benefícios corporativos.',
    buttonText: 'Saiba mais',
    hrefButton:
      'https://ecommerce.caixaprepagos.com.br/?utm_source=CPP&utm_medium=institucional&utm_campaign=standard&utm_content=tagcaixa&_gl=1*1l13qe4*_gcl_au*MTAxMjY2NTY4Ni4xNzU4ODIyMzA4LjM2MzA4MzA1NC4xNzU5ODYwNDcxLjE3NTk4NjA0NzE.*_ga*OTU0MTg1MTE5LjE3NTg4MjIzMDg.*_ga_SNXXFWQEJT*czE3NjU1NDUxNjckbzE3NyRnMSR0MTc2NTU0NTE2OSRqNTgkbDAkaDQwNTY2ODcxMw..*_ga_JC95Z392DC*czE3NjU1NDUxNjckbzEwMyRnMSR0MTc2NTU0NTE5MSRqMzYkbDAkaDc2MTc4MzAzMg..',
    imgSrc: '/assets/hero-imgs/banner-home-1.jpg',
  },
  {
    flag: 'PARA VOCÊ',
    titleOrange: 'tagCAIXA é ',
    titleWhite: 'praticidade para quem não tem tempo a perder.',
    description:
      'A melhor tag de pagamento veicular, aceita em toda a rede Sem Parar. Com tagCAIXA, você paga automaticamente, sem tirar a carteira do bolso, e evita filas em pedágios, postos de combustível, lava-rápidos, drive-thrus e estacionamentos. ',
    buttonText: 'Aproveite esta oferta',
    hrefButton:
      'https://ecommerce.caixaprepagos.com.br/?utm_source=CPP&utm_medium=institucional&utm_campaign=standard&utm_content=tagcaixa',
    imgSrc: '/assets/hero-imgs/banner-home-2.png',
  },
  {
    flag: 'PARA SUA EMPRESA',
    titleOrange: 'Gestão inteligente do vale-transporte ',
    titleWhite: 'é com vtCAIXA',
    description:
      'Emissão, compra e controle do vale-transporte em uma só plataforma, simplificando a administração para empresas de todos os portes. Com vtCAIXA, você conta com processos facilitados e liberação rápida de créditos, reduzindo custos e otimizando o trabalho operacional do RH.',
    buttonText: 'Aproveite esta oferta',
    hrefButton: '/vtcaixa',
    imgSrc: '/assets/hero-imgs/banner-home-3.png',
  },
];

export default function HeroCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);

  const goToSlide = (index: number) => {
    setActiveIndex(index);
  };

  const nextSlide = () => {
    setActiveIndex((prev) => (prev + 1) % heroData.length);
  };

  const prevSlide = () => {
    setActiveIndex((prev) => (prev - 1 + heroData.length) % heroData.length);
  };

  return (
    <div className="w-full relative">
      <div className="w-full mx-auto max-w-7xl">
        {/* Wrapper com padding e espaço extra para a imagem "vazar" */}
        <div className="overflow-x-clip">
          <div
            className="flex transition-transform duration-500 ease-in-out"
            style={{
              transform: `translateX(-${activeIndex * 100}%)`,
              width: `100%`,
            }}
          >
            {heroData.map((heroData, idx) => (
              <div
                key={idx}
                className="w-full px-6 flex-shrink-0"
                style={{ flexBasis: '100%' }}
              >
                {/* <HeroSuaEmpresa {...heroData} /> */}
                <BannerStaticDesktop {...heroData} />
                {/* <MobileHeroSuaempresa {...heroData} /> */}
                <BannerStaticMobile {...heroData} />
              </div>
            ))}
          </div>
        </div>

        {/* Navegação inferior */}
        <div className="mt-6 flex justify-between items-center px-6">
          {/* Bolinhas de navegação */}
          <div className="flex space-x-3">
            {heroData.map((_, index: number) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={cn(
                  'w-4 h-4 rounded-full transition-all focus:outline-none',
                  activeIndex === index ? 'bg-secondary w-10' : 'bg-bluecaixa'
                )}
                aria-label={`Ir para slide ${index + 1}`}
                tabIndex={0}
              />
            ))}
          </div>

          {/* Botões com setas */}
          <div className="flex space-x-4">
            <button
              onClick={prevSlide}
              className="p-2 rounded-full bg-bluecaixa hover:bg-[#0077C4] transition"
              aria-label="Slide anterior"
            >
              <ChevronLeft className="w-5 h-5 text-white" />
            </button>
            <button
              onClick={nextSlide}
              className="p-2 rounded-full bg-bluecaixa hover:bg-[#0077C4] transition"
              aria-label="Próximo slide"
            >
              <ChevronRight className="w-5 h-5 text-white" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
